import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal } from 'carbon-components-react';
import { ButtonKinds } from 'carbon-components-react/lib/prop-types/types';
import { IlModalBodyV2 } from '../IlModalBodyV2/index.js';
import { IlModalFooterV2 } from '../IlModalFooterV2/index.js';
import { FW_PREFIX } from '../../../shared/constants/generalConstants.js';

var _excluded = ["testId", "size", "className", "dialogBody", "modalBodyV2ClassName", "modalFooterV2ClassName", "primaryButtonText", "primaryButtonId", "secondaryButtonText", "secondaryButtonId", "tertiaryButtonText", "tertiaryButtonId", "primaryButtonClick", "primaryButtonDisabled", "secondaryButtonClick", "secondaryButtonDisabled", "tertiaryButtonClick", "tertiaryButtonKind", "tertiaryButtonDisabled", "danger", "primaryButtonTooltipText", "footer"];
var _IlModalV;
var MODAL_SIZE = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var IlModalV2 = /*#__PURE__*/function (_Component) {
  function IlModalV2() {
    _classCallCheck(this, IlModalV2);
    return _callSuper(this, IlModalV2, arguments);
  }
  _inherits(IlModalV2, _Component);
  return _createClass(IlModalV2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        testId = _this$props.testId,
        size = _this$props.size,
        className = _this$props.className,
        dialogBody = _this$props.dialogBody,
        modalBodyV2ClassName = _this$props.modalBodyV2ClassName,
        modalFooterV2ClassName = _this$props.modalFooterV2ClassName,
        primaryButtonText = _this$props.primaryButtonText,
        primaryButtonId = _this$props.primaryButtonId,
        secondaryButtonText = _this$props.secondaryButtonText,
        secondaryButtonId = _this$props.secondaryButtonId,
        tertiaryButtonText = _this$props.tertiaryButtonText,
        tertiaryButtonId = _this$props.tertiaryButtonId,
        primaryButtonClick = _this$props.primaryButtonClick,
        primaryButtonDisabled = _this$props.primaryButtonDisabled,
        secondaryButtonClick = _this$props.secondaryButtonClick,
        secondaryButtonDisabled = _this$props.secondaryButtonDisabled,
        tertiaryButtonClick = _this$props.tertiaryButtonClick,
        tertiaryButtonKind = _this$props.tertiaryButtonKind,
        tertiaryButtonDisabled = _this$props.tertiaryButtonDisabled,
        danger = _this$props.danger,
        primaryButtonTooltipText = _this$props.primaryButtonTooltipText,
        footer = _this$props.footer,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var renderFooter = function renderFooter() {
        if (footer) {
          return footer;
        } else {
          return /*#__PURE__*/React__default.createElement(IlModalFooterV2, {
            primaryButtonText: primaryButtonText,
            primaryButtonId: primaryButtonId,
            secondaryButtonText: secondaryButtonText,
            secondaryButtonId: secondaryButtonId,
            tertiaryButtonText: tertiaryButtonText,
            tertiaryButtonId: tertiaryButtonId,
            primaryButtonClick: primaryButtonClick,
            primaryButtonDisabled: primaryButtonDisabled,
            secondaryButtonClick: secondaryButtonClick,
            secondaryButtonDisabled: secondaryButtonDisabled,
            tertiaryButtonClick: tertiaryButtonClick,
            tertiaryButtonDisabled: tertiaryButtonDisabled,
            tertiaryButtonKind: tertiaryButtonKind,
            danger: danger,
            primaryButtonTooltipText: primaryButtonTooltipText,
            modalFooterV2ClassName: classNames("".concat(modalFooterV2ClassName), "".concat(FW_PREFIX, "__IlModalFooterV2"))
          });
        }
      };
      return /*#__PURE__*/React__default.createElement(Modal, _extends({}, rest, {
        className: classNames("".concat(className), "".concat(FW_PREFIX, "__IlModalV2-").concat(size), "".concat(FW_PREFIX, "__IlModalV2")),
        role: "dialog",
        testid: testId,
        size: size,
        "aria-labelledby": "il-framework-component__IlModalV2",
        id: "il-framework-component__IlModalV2",
        passiveModal: true,
        onScroll: IlModalV2.onScroll
      }), /*#__PURE__*/React__default.createElement(IlModalBodyV2, {
        dialogBody: dialogBody,
        modalBodyV2ClassName: modalBodyV2ClassName
      }), renderFooter());
    }
  }]);
}(Component);
_IlModalV = IlModalV2;
_defineProperty(IlModalV2, "defaultProps", {
  size: MODAL_SIZE.sm,
  passiveModal: true
});
_defineProperty(IlModalV2, "propTypes", _objectSpread2(_objectSpread2({}, _IlModalV.propTypes), {}, {
  testId: PropTypes.string,
  size: PropTypes.string,
  danger: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  primaryButtonId: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonId: PropTypes.string,
  tertiaryButtonText: PropTypes.string,
  tertiaryButtonId: PropTypes.string,
  primaryButtonDisabled: PropTypes.bool,
  primaryButtonClick: PropTypes.func,
  secondaryButtonDisabled: PropTypes.bool,
  secondaryButtonClick: PropTypes.func,
  tertiaryButtonDisabled: PropTypes.bool,
  tertiaryButtonClick: PropTypes.func,
  dialogBody: PropTypes.object,
  className: PropTypes.string,
  passiveModal: PropTypes.bool,
  modalBodyV2ClassName: PropTypes.string,
  modalFooterV2ClassName: PropTypes.string,
  tertiaryButtonKind: PropTypes.oneOf(ButtonKinds),
  primaryButtonTooltipText: PropTypes.string,
  footer: PropTypes.node
}));
_defineProperty(IlModalV2, "onScroll", function (e) {
  e.currentTarget.dataset.scrolledDown = e.target.scrollTop !== 0;
});
IlModalV2.propTypes = {
  footer: PropTypes.node
};

export { IlModalV2, MODAL_SIZE };
